export default __webpack_public_path__ + "static/media/martinize_elastic_groups.8e0b7905.png";